import { render, staticRenderFns } from "./SentRegister.vue?vue&type=template&id=4bdff39b&"
import script from "./SentRegister.vue?vue&type=script&lang=ts&"
export * from "./SentRegister.vue?vue&type=script&lang=ts&"
import style0 from "./SentRegister.vue?vue&type=style&index=0&id=4bdff39b&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports